<script setup lang="ts">
import { ref, watch, computed } from "vue"
import { Button } from "@/components/ui/button"
import { Filter } from "lucide-vue-next"
import * as d3 from 'd3';
import {printHeaderHeight, dayMs, getWidthPerDay, scrollToToday} from "./planner.js";
import Callout from './Callout.vue'
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"

// ... your existing x scale and watch logic ...

// 1. Define cornerHeight as a computed property

const emit = defineEmits(['setProjectFilter']) 

const cornerEl = ref(null)

const active = ref(false)

const props = defineProps({
  projectFilter: {type: Object, required: true},
  configs: { type: Array, required: true },
  printProject: {type: [Object, null], default: null},
});


const startDateStr = props.configs.find(c => c.name === "startdate").value;
const endDateStr = props.configs.find(c => c.name === "enddate").value;
const startDate =  new Date(startDateStr + "T00:00:00");
const endDate = new Date(endDateStr + "T00:00:00");

const totalDays = (endDate - startDate) / dayMs;
const x = d3.scaleUtc().domain([startDate, endDate]).range([0, totalDays * getWidthPerDay(props.printProject !== null)]);

watch(
  () => props.projectFilter.all,
  (newVal) => {
	emit("setProjectFilter", newVal, props.projectFilter.active, props.projectFilter.planned)
  }
);

watch(
  () => props.projectFilter.active,
  (newVal) => {
	emit("setProjectFilter", props.projectFilter.all, newVal, props.projectFilter.planned)
  }
);

watch(
  () => props.projectFilter.planned,
  (newVal) => {
	emit("setProjectFilter", props.projectFilter.all, props.projectFilter.active, newVal)
  }
);

function toggle() {
  console.log("toggle")
  active.value = !active.value
}

const cornerHeight = computed(() => {
  const baseHeight = 96;
  const extraHeight = props.printProject ? printHeaderHeight : 0;
  return `${baseHeight + extraHeight}px`;
});

</script>

<template>

  <div v-if="props.printProject" ref="cornerEl" :style="{height: cornerHeight}" class="printview corner">
    <div style="display: block; width: 60px; height: 60px;">
       <img src="@/components/images/timin.svg" alt="Timin Logo" style="display: block; width: 48px; height: auto;" />
    </div>
  </div>
  
  <div v-if="!props.printProject" ref="cornerEl" :style="{height: cornerHeight}" class="corner flex flex-col space-y-2">
    <button
      id="today-button"
      @click="scrollToToday(x)"
      class="px-3 py-2 rounded bg-blue-500 text-white hover:bg-blue-600"
    >
      Today
    </button>

	<Button
	  class="p-2 text-black hover:text-gray-500"
	  :class="active ? 'bg-slate-100' : 'bg-white'"
	  aria-label="Filter"
	  @click="toggle"
	>
	   <Filter class="w-5 h-5" />
   </Button>
   <Callout id="projectFilterPopup" :target="cornerEl" :show="active" >
	<div class="flex flex-col space-y-2">
	  Projekte filtern
	  <div class="spacer" />
	  <div class="flex flex-col space-y-4 w-64">
		<RadioGroup v-model="props.projectFilter.all" class="flex flex-col space-y-3">
		  <div class="flex items-center space-x-2">
		    <RadioGroupItem id="option1" :value="false" />
		    <Label for="option1">Meine Buchungen</Label>
		  </div>
		  <div class="flex items-center space-x-2">
		    <RadioGroupItem id="option2" :value="true" />
		    <Label for="option2">Alle</Label>
		  </div>
		</RadioGroup>
	  </div>

      <div class="spacer" />
	  
	  <div class="flex flex-col space-y-4 w-64">
		  <div  class="flex items-center space-x-2">
	        <Checkbox
	          id="option1"
	          v-model="props.projectFilter.active"
	        />
	        <Label for="option1">Aktive Projekte</Label>
	      </div>

	      <div class="flex items-center space-x-2">
	        <Checkbox
	          id="option2"
	          v-model="props.projectFilter.planned"
	        />
	        <Label for="option2">Geplante Projekte</Label>
	      </div>
		  
      </div>
	</div>
   </Callout>
  </div>
</template>

<style>

.printview.corner {
  display: block; /* Change from flex if possible */
  padding-left: 10px;
  padding-top: 10px;
  width: 150px; /* Force a width wider than the sidebarWidthMm if needed */
  background-color: white !important;
}

</style>